export default __webpack_public_path__ + "static/media/bg06.e0c1eaf2.svg";